import React, { useState } from "react";
import styles from "./DashboardPage.module.css";
import LeftPanel from "../SwapLeftPanel/LeftPanel";
import ConnectWalletHeader from "../header/ConnectWalletHeader";
import Dashboard from "../../dashboard/components/Dashboard";
import { useIsMobile } from "../utils";

const DashboardPage = () => {
  const [walletAddress, setWalletAddress] = useState("");
  const [showPanel, setShowPanel] = useState(false);
  const isMobile = useIsMobile(1000);

  return (
    <div className={styles.page}>
      <LeftPanel walletAddress={walletAddress} />
      <div className={styles.rightPanel}>
        {isMobile && (
          <ConnectWalletHeader
            onWalletConnected={(publicKey) => setWalletAddress(publicKey)}
            showPanel={showPanel}
            setShowPanel={setShowPanel}
          />
        )}
        <div className={styles.dashboardWrapper}>
          <Dashboard showNav={false} />
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;
